




























































































































































































































































































































































































































































import { bus } from "@/bus";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { version } from "@/../package.json";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions";
import { getExtensionsByAccess } from "@/services/customExtensions/customExtensionService";
import { CustomExtension } from "@/services/customExtensions/types";
import { CurrentUser } from "@/store/authentication/types";
import { FILEENDPOINT } from "@/app.config";

const namespace: string = "authentication";

    @Component
export default class Sidebar extends Vue {
        @Action("logoutAction", { namespace }) logoutAction: any;
        @Getter("getCurrentUser", { namespace }) getCurrentUser!: CurrentUser;
        @Getter("getUserHasFolderAccess", { namespace }) getUserHasFolderAccess: any;

        @Prop() shrinkStatus!: string;
        // local
        permitionEnum = PermitionEnum;
        pinLoaded = false;
        pinStatus = false;
        customExtensions = [] as Array<CustomExtension>;

        havePermition = HavePermition;

        beforeUpdate() {
            this.showPin();
        }

        mounted(): void {
            this.fetchExtensions();
        }

        InitiateReload() {
            bus.$emit("reload");
        }

        onLogout(): void {
            this.logoutAction();
            this.$router.push("/login");
        }

        emitPinStatus() {
            this.pinStatus = !this.pinStatus;
            this.$emit("pin-status", this.pinStatus);
        }

        // computed
        get name(): string {
            return `${this.getCurrentUser.firstName} ${this.getCurrentUser.lastName}`;
        }

        get currentRoute() {
            return this.$route.path || "";
        }

        get appVersion(): string {
            return version;
        }

        get initials(): string {
            let firstNameInitial = "";
            let lastNameInitial = "";
            if (this.getCurrentUser.firstName) firstNameInitial = this.getCurrentUser.firstName.charAt(0);
            if (this.getCurrentUser.lastName) lastNameInitial = this.getCurrentUser.lastName.charAt(0);
            return `${firstNameInitial}${lastNameInitial}`;
        }

        showPin() {
            if (!this.shrinkStatus && !this.pinStatus) {
                setTimeout(() => { this.pinLoaded = true; }, 700);
            } else {
                this.pinLoaded = true;
            }
        }

        @Watch("getCurrentUser", { deep: true }) currentUserUpdate() {
            this.fetchExtensions();
        }

        fetchExtensions() {
            getExtensionsByAccess().then(response => {
                this.customExtensions = response;
            });
        }

        // for backdoor users we return empty list always
        get filteredCustomExtensions(): CustomExtension[] {
            if (this.getCurrentUser.isBackdoorUser) {
                return [];
            }
            return this.customExtensions;
        }

        imageUrl(extension: CustomExtension): string {
            return `${FILEENDPOINT}${extension.menuIconFileId}`;
        }
}
